import React from "react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import OurStory from "@/components/OurStory";
import AmbedkarSection from "@/components/AmbedkarSection";
import PathToSalvation from "@/components/PathToSalvation";
import VisionMission from "@/components/VisionMission";
import GoverningCouncil from "@/components/GoverningCouncil";
import WomensWingCoordinators from "@/components/WomensWingCoordinators";
import BuddhaAndDhamma from "@/components/BuddhaAndDhamma";
import ConferenceGallery from "@/components/ConferenceGallery";
import Initiatives from "@/components/Initiatives";
import ActivitiesAndImpact from "@/components/ActivitiesAndImpact";
import DonationSection from "@/components/DonationSection";
import VolunteerSection from "@/components/VolunteerSection";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <OurStory />
      <AmbedkarSection />
      <PathToSalvation />
      <VisionMission />
      <GoverningCouncil />
      <WomensWingCoordinators />
      <BuddhaAndDhamma />
      <ConferenceGallery />
      <Initiatives />
      <ActivitiesAndImpact />
      <DonationSection />
      <VolunteerSection />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
